<template>
  <!-- HEADER -->
  <header class="a-vs-c--header-container" ref="videoBlock">
    <!-- Everything bellow this line, to the end of HEADER belongs ON (over) the video -->
    <!-- Top overlay with jackpots and total odds -->
    <div class="video-container" ref="scaleElement">
      <!--<vdog-jackpot-result />-->
      <div @click="switchPlayer" ref="videotag" class="a-vs-header--video" id="video"
      :class="{'hide-player': opacityClass, 'show-player': !opacityClass}">
        <video-container
          v-if="isRealPlayerActive()"
          :seek="videoSeek"
          :videoList="videoList"
          @onError="onError($event)"
          @onTime="onTime($event)"
          @onPlay="onPlay($event)"
          @onComplete="onComplete($event)" />

        <div class="virtual-video-container">
          <vg-video-container
            v-if="isVirualPlayerActive()"
            :seek="videoSeek"
            :videoList="videoList"
            :roundLength="roundLength"
            :totalVideoLength="totalVideoLength"
            @onError="onError($event)"
            @onTime="onTime($event)"
            @onPlay="onPlay($event)"
            @onComplete="onComplete($event)" />
        </div>

        <div class="virtual-video-container">
          <!-- videoJackpotType -->
            <vg-jactpot-video-player
              v-if="isJackpotPlayerActive()"
              :totalVideoLength="jackpotVideoLength"
              :type="this.jackpotData.videoJackpotType"
              :videoList="videoList"
              @onError="onError($event)"
              @onTime="onTime($event)"
              @onPlay="onPlay($event)"
              @onComplete="onComplete($event, true)"/>
        </div>

        <slider-player v-show="isSliderEnabled" :data="getDataForSlider()" />

        <div v-if="isDemoMode" class="a-vs-header--demo-mode"></div>

        <div class="overlay-bar-vs"
          v-if="headerResultShow && isCurrentGameExists && this.fullScreenActive">
          <div class="a-vs-header--overlay-bottom">
            <result-line
              :currentGame="currentGame"
              :headerResult="headerResult"
              :headerResultHomeScore="headerResult.HomeScore"
              :headerResultAwayScore="headerResult.AwayScore" />
          </div>
        </div>
        <full-screen-button
          :marginBottom="marginBottomFS"  @toggleFullScreen="toggleFullScreen" />
      </div>
    </div>
  </header>
</template>

<script>
import MobileDevice from '@/mixins/MobileDevice'
import FullScreen from '@/mixins/FullScreen.js'
import Jackpot from '@/mixins/Jackpot'
import EventConstants from '@/constants/Events'

import Slider from '@/components/soccer/slides/Slider.vue'
import FullScreenButton from '@/components/common/FullScreenButton.vue'
import VideoContainer from '@/components/soccer/header/VideoContainer.vue'
import VirtualGameVideoContainer from '@/components/soccer/header/VirtualGameVideoContainer.vue'
import JackpotVideoPlayer from '@/components/soccer/header/JackpotVideoPlayer.vue'
import VideoPositioning from '@/mixins/VideoPositioning.js'

import { eventBus } from '@/main.js'
import { store } from '@/store/store.js'

export default {
  mixins: [MobileDevice, FullScreen, Jackpot, VideoPositioning],
  components: {
    'slider-player': Slider,
    'full-screen-button': FullScreenButton,
    'video-container': VideoContainer,
    'vg-video-container': VirtualGameVideoContainer,
    'vg-jactpot-video-player': JackpotVideoPlayer
  },
  props: {
    videoList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isDemoMode: {
      type: Boolean,
      default: false
    },
    roundLength: {
      type: Number
    },
    totalVideoLength: {
      type: Number
    },
    seek: {
      type: Number,
      default: 0
    },
    metaDataVideoList: {
      type: Array
    },
    showFallenJackpots: {
      type: Boolean,
      default: false
    },
    showMatchResult: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: ''
    },
    videoResult: {
      type: Object,
      default: function () { return {} }
    },
    headerResultShow: {
      type: Boolean,
      default: false
    },
    fallenJackpots: {
      type: Object,
      default: null
    },
    headerResult: {
      type: Object,
      required: true
    },
    currentGame: {
      type: Object
    }
  },
  data () {
    return {
      isVideoPlaying: true,
      isVideoAllowed: true,
      videoSeek: 0,
      jackpotVideoLength: 0,
      secondsToStart: 0,
      fullScreenActive: false,
      jackpotData: null,
      startPlayingJackpot: false,
      showingVideoResult: false,
      hideMatchResultTimerAfter: 15000, // 15s
      elementVideoBlock: null,
      elementVideo: null,
      elementVGamesBody: null,
      elementScaleElement: null,
      'window': {
        width: 0,
        height: 0
      },
      'marginBottom': '',
      showPlayerOpacity: true
    }
  },
  watch: {
    seek: function (val, old) {
      this.videoSeek = val
    }
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VIDEO_POSITIONING, this.videoPositioning)
    eventBus.$off(EventConstants.SET_FULLSCREEN, this.onSetFullScreen)
    eventBus.$off(EventConstants.VSOCCER_SHOW_JACKPOT_VALUE, this.jackpotEventListener)
    eventBus.$off(EventConstants.VSOCCER_TIMER_TICK, this.onEventTimerTick)
    document.removeEventListener('fullscreenchange', this.exitHandler)
    document.removeEventListener('mozfullscreenchange', this.exitHandler, false)
    document.removeEventListener('MSFullscreenChange', this.exitHandler, false)
    document.removeEventListener('webkitfullscreenchange', this.exitHandler, false)
  },
  created: function () {
    eventBus.$on(EventConstants.VIDEO_POSITIONING, this.videoPositioning)
    eventBus.$on(EventConstants.VSOCCER_SHOW_JACKPOT_VALUE, this.jackpotEventListener)
    eventBus.$on(EventConstants.SET_FULLSCREEN, this.onSetFullScreen)
    eventBus.$on(EventConstants.VSOCCER_TIMER_TICK, this.onEventTimerTick)
    document.addEventListener('fullscreenchange', this.exitHandler, false)
    document.addEventListener('mozfullscreenchange', this.exitHandler, false)
    document.addEventListener('MSFullscreenChange', this.exitHandler, false)
    document.addEventListener('webkitfullscreenchange', this.exitHandler, false)
  },
  mounted: function () {
    this.elementVideoBlock = this.$refs.videoBlock
    this.elementVideo = this.$refs.videotag
    this.elementVGamesBody = document.getElementById('VGamesBody')
    this.elementScaleElement = this.$refs.scaleElement
    this.isVideoPlaying = store.isAutoPlayEnabled() && store.isVideoAllowed()
    this.isVideoAllowed = store.isVideoAllowed()
  },
  methods: {
    isRealPlayerActive: function () {
      return this.isVideoPlaying
    },
    isVirualPlayerActive: function () {
      return !this.isVideoPlaying && this.jackpotVideoLength === 0 && (!this.isSliderEnabled || this.isJackpotActive())
    },
    isJackpotPlayerActive: function () {
      return !this.isVideoPlaying && this.jackpotVideoLength !== 0 && this.isJackpotActive()
    },
    onEventTimerTick: function (secondsToStart) {
      this.secondsToStart = secondsToStart
    },
    jackpotEventListener: function (data) {
      if (!data) {
        this.startPlayingJackpot = false
        this.jackpotData = null
      }
    },
    onSetFullScreen: function (data) {
      if (!data && this.fullScreenActive) {
        this.cancelFullScreen()
      }
    },
    switchPlayer: function () {
      if (!store.isPauseAllowed()) return
      if (this.isSliderEnabled) return
      if (!this.isVideoAllowed) return
      this.videoSeek = this.roundLength - this.secondsToStart
      this.isVideoPlaying = !this.isVideoPlaying
      store.setAutoPlay(this.isVideoPlaying)
    },
    onError: function (event) {
      store.setGameInProgress(false)
      this.$emit('onError', event)
    },
    showJackpotResultOnSlider: function (event) {
      let metaData = null
      if (this.jackpotData.metadata && this.jackpotData.metadata.length > 0) {
        metaData = this.jackpotData.metadata[0]
      }
      if (metaData && event.data.currentTime > metaData.Time) {
        let metaDataElement = this.jackpotData.metadata.shift()
        eventBus.showJackpotValue(metaDataElement.Ticket)
      }
    },
    showGameResults: function (event) {
      if (!this.headerResultShow) {
        eventBus.onShowResultsHeader(true)
      }
      let metaData = null
      if (this.metaDataVideoList && this.metaDataVideoList.length > 0) {
        metaData = this.metaDataVideoList[0]
      }
      if (metaData && (event.data.currentTime * 1000) > metaData.Time) {
        if (this.metaDataVideoList && this.metaDataVideoList.length > 0) {
          let videoMetaData = this.metaDataVideoList.shift()
          eventBus.showNewScore(videoMetaData)
        }
      }
    },
    isJackpotActive: function () {
      return this.startPlayingJackpot && this.jackpotData && this.jackpotData.isJackpotActive
    },
    onTime: function (event) {
      store.setGameInProgress(true)
      if (this.showPlayerOpacity) this.showPlayerOpacity = false
      if (this.isJackpotActive()) {
        this.showJackpotResultOnSlider(event)
      } else {
        this.showGameResults(event)
      }
    },
    onComplete: function (event, isJackpot) {
      if (isJackpot) {
        this.jackpotVideoLength = 0
      }
      this.showPlayerOpacity = true
      eventBus.onShowResultsHeader(false)
      store.setGameInProgress(false)
      if (!this.startPlayingJackpot) {
        this.getWinningJackpotData()
      } else {
        eventBus.showJackpotValue(null)
        this.startPlayingJackpot = false
        this.jackpotData = null
        this.showDataResult()
      }
    },
    onPlay: function (event) {
      store.setGameInProgress(true)
      this.showPlayerOpacity = true
    },
    showDataResult () {
      eventBus.onShowResultsHeader(false)
      eventBus.onRefreshActiveBets()
      setTimeout(() => {
        eventBus.onBettingHistoryRefresh()
      }, 500)
      this.showingVideoResult = true
      eventBus.onShowMatchResult(true)
      setTimeout(() => {
        this.showingVideoResult = false
        eventBus.onShowMatchResult(false)
      }, this.hideMatchResultTimerAfter)
    },
    getDataForSlider () {
      return {
        'showingVideoResult': this.showingVideoResult,
        'videoList': this.videoList.length,
        'showSlider': this.showSlider,
        'showFallenJackpots': this.showFallenJackpots,
        'showMatchResult': this.showMatchResult,
        'videoResult': this.videoResult,
        'currency': this.currency,
        'fallenJackpots': this.fallenJackpots
      }
    },
    getWinningJackpotData () {
      this.showingVideoResult = false
      this.getWinningJackpot().subscribe(data => {
        this.jackpotData = data
        if (data.isJackpotActive) {
          this.startPlayingJackpot = true
          this.videoList.push(data.videoLink)
          this.videoSeek = 0
          if (!this.isVideoPlaying) {
            // for fake player
            this.jackpotVideoLength = 20
          }
        } else {
          this.showDataResult()
        }
      })
    }
  },
  computed: {
    showSlider: function () {
      return this.videoList.length === 0 && !this.showingVideoResult
    },
    isSliderEnabled: function () {
      return (this.showMatchResult && this.videoResult && this.showingVideoResult) || (this.showSlider && !this.showMatchResult) || this.showFallenJackpots
    },
    marginBottomFS: function () {
      return this.marginBottom
    },
    opacityClass: function () {
      return this.isSliderEnabled ? false : this.showPlayerOpacity
    },
    isCurrentGameExists: function () {
      return this.currentGame != null
    },
    isHeaderResultShow: function () {
      return this.headerResultShow
    }
  }
}
</script>
